import { useAppSelector, useAppDispatch } from "../store/hooks"
import { selectNotification, notificationSlice } from "../Notification"

function NotificationProvider() {
    const notification = useAppSelector(selectNotification)
    const dispatch = useAppDispatch()

    const handleNotificationClick = (id: string) => {
        dispatch(notificationSlice.actions.removeNotification(id))
    }

    // Separate persistent and regular notifications
    const persistentNotifications = notification.filter(n => n.persistent)
    const regularNotifications = notification.filter(n => !n.persistent)

    return (
        <>
            {/* Regular notifications in top-right */}
            <div className={"fixed right-4 top-4 flex flex-col space-y-4 z-50"}>
                {regularNotifications.map((n) => (
                    <div
                        key={n.id}
                        className={"py-3 px-6 bg-white border border-blue-600 rounded shadow w-full"}>
                        <div className={"font-bold text-blue-600"}>{n.title}</div>
                        <div className={"text-sm tracking-wide"}>{n.message}</div>
                    </div>
                ))}
            </div>

            {/* Backdrop blur for persistent notifications */}
            {persistentNotifications.length > 0 && (
                <div className={"fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-40"} />
            )}

            {/* Persistent notifications in center */}
            <div className={"fixed inset-0 flex items-center justify-center pointer-events-none z-50"}>
                <div className={"flex flex-col space-y-4 max-w-md w-full mx-4 pointer-events-auto"}>
                    {persistentNotifications.map((n) => (
                        <div
                            key={n.id}
                            className={"py-4 px-6 bg-white border border-blue-600 rounded-lg shadow-lg w-full relative text-lg"}>
                            {/* X button in top-right corner */}
                            <button
                                onClick={() => handleNotificationClick(n.id)}
                                className={"absolute top-2 right-2 w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full transition-colors"}
                                aria-label="Schließen"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            
                            <div className={"font-bold text-blue-600 text-xl"}>{n.title}</div>
                            <div className={"tracking-wide mt-2"}>{n.message}</div>
                            
                            {/* Verstanden! button */}
                            <div className={"mt-4 flex justify-center"}>
                                <button
                                    onClick={() => handleNotificationClick(n.id)}
                                    className={"px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors text-lg"}
                                >
                                    Verstanden!
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default NotificationProvider
